import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { APP_NAME } from '@config/app.config'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="auth-layout">
      <div className="auth-container">
        <div className="auth-header">
          <Link to="/">
            <h1>{APP_NAME}</h1>
          </Link>
        </div>
        <div className="auth-content">{children}</div>
        <div className="auth-footer">
          <p>&copy; 2025 {APP_NAME}. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}
